const elements = {
  selects: document.body.querySelectorAll('.js-select-field'),
};

function init() {
  elements.selects.forEach((select) => {
    if (select.value) {
      return select.classList.add('is-active');
    }
    select.addEventListener('change', () => {
      select.classList.add('is-active');
    });
    return null;
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/forms/select/select.js